import Settings from "./Container"

export default Settings
